import { render, staticRenderFns } from "./MListCard.vue?vue&type=template&id=1cd42aff"
import script from "./MListCard.vue?vue&type=script&lang=js"
export * from "./MListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports